import React, { FunctionComponent, ReactNode } from 'react';
import { Colors, Theme } from '@inplayer-org/inplayer-ui';
import styled, { StyledComponent } from 'styled-components';

// styled components
import { Country, Region, City } from 'ducks/merchantDucks/restrictions/types';
import { BlueTypography } from './SharedStyledElements';

const Block: StyledComponent<'div', Theme> = styled.div`
  min-height: 10vh;
  border: 1px solid ${Colors.gray};
  box-sizing: border-box;
  border-radius: 3px;
  position: relative;
  transition: all 200ms ease-in-out;
  height: 100%;
  width: 100%;
  min-width: 0;
  padding: 0.5rem;
  cursor: auto;
`;

export const ThinTypography = styled(BlueTypography)<{ color?: string }>`
  font-weight: ${({ theme }) => theme.font.weights.thin};
  font-style: normal;
  transition: all 200ms ease-in-out;
  ${({ color }) => color && `color: ${color};`}
`;

export const BoxItemContent: StyledComponent<'div', Theme> = styled.div`
  width: 100%;
  height: 100%;
`;

type ImageProp = { image?: string };

const BoxItemBlock: StyledComponent<'div', Theme, ImageProp> = styled(Block)`
  ${({ image }: ImageProp) => (image ? `background: url(${image});` : '')}
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 0;
`;

export interface Item {
  id: number;
  title: string;
  brand_name: string;
  items: number;
  is_active: boolean;
  metadata?: any;
  default: boolean;
  paywall_cover_photo: string;
  type: string;
  name: string;
  global: any;
  countries: Country[];
  regions: Region[];
  cities: City[];
  item_type: { content_type: string };
}

interface OwnProps {
  boxItem?: Item;
  children?: ReactNode;
  backgroundImgSrc?: string;
  render?: (item: Item) => ReactNode;
}

const BoxItem: FunctionComponent<OwnProps> = ({ boxItem, backgroundImgSrc, render }) => {
  if (!boxItem) {
    return null;
  }

  return (
    <BoxItemBlock key={boxItem.id} image={backgroundImgSrc}>
      <BoxItemContent>{render && render(boxItem)}</BoxItemContent>
    </BoxItemBlock>
  );
};

export default BoxItem;
